import { createFileRoute } from '@tanstack/react-router';
import { StaffingCategoriesPage } from '@/pages/staffing/StaffingCategoriesPage';

export const Route = createFileRoute('/_authenticated/_app/staffing/categories')({
	component: StaffingCategoriesPage,
});
